// @flow
import axios from 'lib/defaultClient';

// 배송지 목록 조회
export const getShippingAddresses = () => axios.get('/me/shipping-addresses');

// 배송지 추가
export const createShippingAddress = (addressData: {
  name: string,
  company?: string,
  country: string,
  state: string,
  city: string,
  postcode: string,
  address1: string,
  address2?: string,
  mobile: string,
  phone?: string,
  label?: string,
  is_default?: boolean,
}) => axios.post('/me/shipping-addresses', addressData);

// 배송지 수정
export const updateShippingAddress = (
  id: string,
  addressData: {
    name?: string,
    company?: string,
    country?: string,
    state?: string,
    city?: string,
    postcode?: string,
    address1?: string,
    address2?: string,
    mobile?: string,
    phone?: string,
    label?: string,
    is_default?: boolean,
  },
) => axios.patch(`/me/shipping-addresses/${id}`, addressData);

// 배송지 삭제
export const deleteShippingAddress = (id: string) => axios.delete(`/me/shipping-addresses/${id}`);

// 기본 배송지 설정
export const setDefaultShippingAddress = (id: string) =>
  axios.patch(`/me/shipping-addresses/${id}/set-default`, {});



// WEBPACK FOOTER //
// ./src/lib/api/me/shippingAddresses.js